import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApiInstance from "app/services/axios";
import { DATASOURCE_CONFIG } from "app/config";
import { convertStringToInt, tabDataQuery } from "./reportingQueryUtill";
import {
  attibutionHourlyReportingTable,
  dataStoreRealTimeTable,
  eventHourlyReportingTable,
  getDataEndPoint,
  getRegionIDReportingDataEndPoint,
  getReportingDataEndPoint,
} from "app/utils/constants/paths";
import moment from "moment";
import { REPORTING_INHOUSE_DSPS } from "app/utils/constants/configurations";
import cloneDeep from "lodash.clonedeep";
let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  tileLoading: false,
  reportingTabsData: {},
  tabLoaders: [],
  pincodesList: [],
};

const CampaignAttributionReport = createSlice({
  name: "CampaignAttributionReport",
  initialState,
  reducers: {
    updateTabLoaders(state, action) {
      state.tabLoaders.push(action.payload);
    },

    resetReportingData(state, action) {
      state.reportingTabsData = {};
      state.tabLoaders = [];
    },
  },

  extraReducers(builder) {
    builder

      .addCase(GetAttributionReportingOverviewDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(
        GetAttributionReportingOverviewDataThunk.fulfilled,
        (state, action) => {
          const dbResponse = action.payload.data.results;

          if (dbResponse && dbResponse.length) {
            let dbVisitsArrObj = cloneDeep(dbResponse[0]);
            let dbUniquesArrObj =
              dbResponse.length > 1 ? cloneDeep(dbResponse[1]) : [];
            let dbMinutesArrObj =
              dbResponse.length > 2 ? cloneDeep(dbResponse[2]) : [];

            let visitsArr = convertStringToInt(dbVisitsArrObj, []);
            let uniquesArr =
              dbResponse.length > 1
                ? convertStringToInt(dbUniquesArrObj, [])
                : {};

            let minutesArr =
              dbResponse.length > 2
                ? convertStringToInt(dbMinutesArrObj, [])
                : {};

            let visits = visitsArr[0]?.["visits"]
              ? visitsArr[0]?.["visits"]
              : 0;
            let uniques = uniquesArr[0]?.["uniques"]
              ? uniquesArr[0]?.["uniques"]
              : 0;

            let minutes = minutesArr[0]?.["total_minutes_difference"]
              ? minutesArr[0]?.["total_minutes_difference"]
              : 0;

            let visitRate =
              visits > 0 && minutes > 0 ? minutes / 1440 / visits : 0;

            if (state.reportingTabsData[action.meta.arg.tab]) {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: {
                  visits: visits,
                  uniques: uniques,
                  visitRate: visitRate,
                },
                updatedAt: moment().format("x"),
              };

              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");
            } else {
              state.reportingTabsData[action.meta.arg.tab] = {};
              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");

              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: {
                  visits: visits,
                  uniques: uniques,
                  visitRate: visitRate,
                },
                updatedAt: moment().format("x"),
              };
            }
          } else {
            if (state.reportingTabsData[action.meta.arg.tab]) {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: {},

                updatedAt: moment().format("x"),
              };

              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");
            } else {
              state.reportingTabsData[action.meta.arg.tab] = {};
              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");

              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: {},

                updatedAt: moment().format("x"),
              };
            }
          }

          if (
            state.tabLoaders.indexOf(
              action.meta.arg.tab + "_" + action.meta.arg.action
            ) != -1
          ) {
            state.tabLoaders.splice(
              state.tabLoaders.indexOf(
                action.meta.arg.tab + "_" + action.meta.arg.action
              ),
              1
            );
          }
        }
      )
      .addCase(
        GetAttributionReportingOverviewDataThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
        }
      )
      .addCase(GetAttributionGroupByDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(GetAttributionGroupByDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results;
        if (dbResponse && dbResponse.length) {
          let finalDataObj = dbResponse[0];

          finalDataObj = convertStringToInt(finalDataObj, []);

          if (state.reportingTabsData[action.meta.arg.tab]) {
            state.reportingTabsData[action.meta.arg.tab][
              action.meta.arg.action
            ] = {
              data: finalDataObj,
              updatedAt: moment().format("x"),
            };

            state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
              moment().format("x");
          } else {
            state.reportingTabsData[action.meta.arg.tab] = {};
            state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
              moment().format("x");

            state.reportingTabsData[action.meta.arg.tab][
              action.meta.arg.action
            ] = {
              data: finalDataObj,
              updatedAt: moment().format("x"),
            };
          }
          if (
            state.tabLoaders.indexOf(
              action.meta.arg.tab + "_" + action.meta.arg.action
            ) != -1
          ) {
            state.tabLoaders.splice(
              state.tabLoaders.indexOf(
                action.meta.arg.tab + "_" + action.meta.arg.action
              ),
              1
            );
          }
        }
        state.tileLoading = false;
      })
      .addCase(GetAttributionGroupByDataThunk.rejected, (state) => {
        // state.dashboardPreInfoLoader = false;
      });
  },
});

/****** ATTRIBUTION RELATED FUNCTIONS  ** */
export const GetAttributionReportingOverviewDataThunk = createAsyncThunk(
  "report/GetAttributionReportingOverviewDataThunk",
  async (payload) => {
    let userTimeZone = payload.timezone;
    let start_date = payload.start_date;
    let end_date = payload?.end_date;
    let accounts = [];
    let campaigns = [];

    if (payload?.reportCampaignId) {
      start_date = moment(payload.reportStartDate).format(
        "YYYY-MM-DD 00:00:00"
      );
      end_date =
        payload?.reportEndDate != null &&
        payload?.reportEndDate != "" &&
        payload?.reportEndDate != "0000-00-00 00:00:00"
          ? moment(payload.reportEndDate).format("YYYY-MM-DD 23:59:59")
          : moment
              .tz(
                moment.utc().format("YYYY-MM-DD HH:mm:ss"),
                "YYYY-MM-DD HH:mm:ss",
                "UTC"
              )
              .tz(userTimeZone)
              .format("YYYY-MM-DD 23:59:59");
      accounts = [];
      campaigns = [payload?.reportCampaignId];
    }

    let WC = [];
    if (start_date != null && start_date != "") {
      WC.push(
        `date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}') `
      );
    }

    if (end_date != null && end_date != "") {
      WC.push(
        `date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}') `
      );
    }

    if (accounts?.length > 0) {
      let accountsStr = "'" + accounts.join("','") + "'";
      WC.push(`hourly.accid IN(${accountsStr})`);
    }

    if (campaigns?.length > 0) {
      let campaignsStr = "'" + campaigns.join("','") + "'";
      WC.push(`hourly.cid IN(${campaignsStr})`);
    }

    let whrCondition = "";
    if (WC.length > 0) {
      whrCondition = " where " + WC.join(" and ");
    }

    var q =
      "select count(*) as visits from " +
      attibutionHourlyReportingTable +
      "  as hourly  " +
      whrCondition;

    let queriesArr = [
      {
        query: q,
        datasource: "redshift",
      },
    ];

    var uniquesQuery = "";
    if (payload?.reportCampaignId) {
      uniquesQuery =
        `SELECT COUNT(*) AS uniques FROM (select ip,userid,sup_ip,sup_userid ` +
        ` from ` +
        attibutionHourlyReportingTable +
        ` as hourly ` +
        whrCondition +
        " group by ip,userid,sup_ip,sup_userid) as unique_rows";

      queriesArr.push({ query: uniquesQuery, datasource: "redshift" });
    }

    //DifferenceInMinutesQuery

    var minutesQuery = "";
    if (payload?.reportCampaignId) {
      minutesQuery =
        `SELECT sum(DATEDIFF(minute, \"timestamp\", \"date_time\")) AS total_minutes_difference ` +
        ` from ` +
        attibutionHourlyReportingTable +
        ` as hourly ` +
        whrCondition +
        "";

      queriesArr.push({ query: minutesQuery, datasource: "redshift" });
    }

    //console.log("Query:", queriesArr);
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAttributionGroupByDataThunk = createAsyncThunk(
  "report/GetAttributionGroupByDataThunk",
  async (payload) => {
    let userTimeZone = payload.timezone;
    let start_date = payload.start_date;
    let end_date = payload?.end_date;
    let accounts = [];
    let campaigns = [];
    let tab = payload?.tab;
    let action = payload?.action;
    let orderby =
      payload?.orderby && payload.orderby != ""
        ? "order by " + payload.orderby
        : "";

    if (payload?.reportCampaignId) {
      start_date = moment(payload.reportStartDate).format(
        "YYYY-MM-DD 00:00:00"
      );
      end_date =
        payload?.reportEndDate != null &&
        payload?.reportEndDate != "" &&
        payload?.reportEndDate != "0000-00-00 00:00:00"
          ? moment(payload.reportEndDate).format("YYYY-MM-DD 23:59:59")
          : moment
              .tz(
                moment.utc().format("YYYY-MM-DD HH:mm:ss"),
                "YYYY-MM-DD HH:mm:ss",
                "UTC"
              )
              .tz(userTimeZone)
              .format("YYYY-MM-DD 23:59:59");
      accounts = [];
      campaigns = [payload?.reportCampaignId];
    }

    let WC = [];
    if (start_date != null && start_date != "") {
      WC.push(
        `date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}') `
      );
    }

    if (end_date != null && end_date != "") {
      WC.push(
        `date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}') `
      );
    }

    if (accounts?.length > 0) {
      let accountsStr = "'" + accounts.join("','") + "'";
      WC.push(`hourly.accid IN(${accountsStr})`);
    }

    if (campaigns?.length > 0) {
      let campaignsStr = "'" + campaigns.join("','") + "'";
      WC.push(`hourly.cid IN(${campaignsStr})`);
    }

    let whrCondition = "";
    if (WC.length > 0) {
      whrCondition = " where " + WC.join(" and ");
    }

    //Check GroupBy and Prepare Query

    var q = "";
    if (tab == "campaign_day") {
      q =
        "select TO_CHAR(CONVERT_TIMEZONE('UTC', 'UTC', date_time),'YYYY-MM-DD') as date,count(*) as visits,cid as campaign_id from " +
        attibutionHourlyReportingTable +
        "  as hourly  " +
        whrCondition +
        " group by date,cid " +
        orderby;
    } else if (tab == "device_type" && action == "visits") {
      q =
        "select count(*) as visits, devicetype as device_type from " +
        attibutionHourlyReportingTable +
        "  as hourly  " +
        whrCondition +
        " group by devicetype order by visits desc limit 10";
    } else if (tab == "device_type" && action == "uniques") {
      q =
        "select count(*) as uniques, devicetype as device_type from (select ip,userid,sup_ip,sup_userid,devicetype from " +
        attibutionHourlyReportingTable +
        " as hourly " +
        whrCondition +
        "  group by ip,userid,sup_ip,sup_userid,devicetype) as unique_combinations " +
        " group by device_type order by uniques desc limit 10";
    } else if (tab == "device_os" && action == "visits") {
      q =
        "select count(*) as visits, os from " +
        attibutionHourlyReportingTable +
        "  as hourly  " +
        whrCondition +
        " group by os order by visits desc limit 10";
    } else if (tab == "device_os" && action == "uniques") {
      q =
        "select count(*) as uniques, os from (select ip,userid,sup_ip,sup_userid,os from " +
        attibutionHourlyReportingTable +
        " as hourly " +
        whrCondition +
        "  group by ip,userid,sup_ip,sup_userid,os) as unique_combinations " +
        " group by os order by uniques desc limit 10";
    } else if (tab == "geohash") {
      q =
        "select count(*) as visits, geohash from " +
        attibutionHourlyReportingTable +
        "  as hourly  " +
        whrCondition +
        " group by geohash order by visits desc";
    }

    let queriesArr = [
      {
        query: q,
        datasource: "redshift",
      },
    ];

    //console.log("Query:", queriesArr);
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const { actions, reducer } = CampaignAttributionReport;
export const { updateTabLoaders, resetReportingData } = actions;
export default reducer;
